export enum NetworkType {
    G2 = '2G',
    G4 = '4G',
    G5 = '5G',
}
